/* eslint-disable func-names */
/* eslint-disable max-len */
/* eslint-disable no-return-assign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import {
  Card, CardBody, Col, ButtonToolbar, Button, Modal, ModalHeader, ModalBody, ModalFooter, Progress,
} from 'reactstrap';
import { message } from 'antd';
import { URL_INSTRUCTORMAPPING, URL_INSTRUCTOR } from '../../../../../../utils/EndPoints';
import { LOCALSTORAGE_TOKEN } from '../../../../../../utils/Types';
import renderSelectField from '../../../../../../shared/components/form/Select';

const EditInstructorForm = (stateOri) => {
  const history = useHistory();
  const { id } = useParams();
  const { location } = history;
  const { state } = location;
  const { data } = state;
  const { initialize } = stateOri;

  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState();

  const [isEditable, setEditable] = useState(false);
  const [instructors, setInstructors] = useState([]);
  const [confirm, setConfirm] = useState(0);
  const [modal, setModal] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const toggle = (idInstructor) => {
    setConfirm(idInstructor);
    setModal(!modal);
  };

  useEffect(() => {
    initialize({
      ...data,
      userId: { value: `${data?.instructor_detail.Id}`, label: data?.instructor_detail?.name },
    });
    const token = localStorage.getItem(LOCALSTORAGE_TOKEN);
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${token}`,
      },
    };

    axios
      .get(`${URL_INSTRUCTOR}`, options)
      .then((res) => {
        setInstructors(
          res.data.map((item) => ({
            value: `${item.id}`,
            label: `${item.name}`,
          })),
        );
      })
      .catch(() => {
        message.error('Something went wrong!');
      });
  }, []);

  const onSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    const dataEdit = new FormData();
    dataEdit.append('instructorId', e.target.userId.value);
    const token = localStorage.getItem(LOCALSTORAGE_TOKEN);
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${token}`,
      },
      onUploadProgress: () => {
        setProgress(Math.round((100 * data.loaded) / data.total));
      },
    };
    axios.patch(`${URL_INSTRUCTORMAPPING}${id}/`, dataEdit, options)
      .then((res) => {
        messageApi.success('Instructor Successfully Updated');
        history.push({
          pathname: `/admin/course-curriculum/${res.data.courseId}`,
          search: '?tabs=4',
        });
        setLoading(false);
      })
      .catch(() => {
        messageApi.error('Instructor Failed Updated');
        setLoading(false);
      });
  };
  return (
    <Col md={12} lg={12}>
      {
        contextHolder
      }
      <Card className="card--not-full-height">
        <CardBody className="dashboard__booking-card">
          <form className="form" onSubmit={onSubmit}>
            <span className="form__form-group-label">Instuctor</span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="userId"
                  component={renderSelectField}
                  type="text"
                  options={instructors}
                  placeholder="Select Instructor"
                  required
                />
              </div>
            </div>

            {loading && (
              <Card>
                <Col md={12} lg={12}>
                  <Progress animated value={progress}>{progress}%</Progress>
                </Col>
              </Card>
            )}

            <ButtonToolbar className="form__button-toolbar">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setEditable(!isEditable)}
                color={isEditable ? 'danger' : 'primary'}
              >
                {' '}
                {!isEditable ? 'Change' : 'Cancel'}
              </button>
              {isEditable && (
              <button
                type="submit"
                className="btn btn-primary"
              >
                Save
              </button>
              )}
              {isEditable === false && (
              <button
                type="button"
                size="sm"
                onClick={() => toggle(data?.id)}
                className="btn btn-danger"
              >
                Delete
              </button>
              )}
              <Modal
                toggle={toggle}
                isOpen={modal}
                backdrop={false}
              >
                <ModalHeader toggle={toggle}>
                  Delete Instructor?
                </ModalHeader>
                <ModalBody>
                  Are you sure you want to Delete this Instructor?
                </ModalBody>
                <ModalFooter>
                  <Button
                    onClick={() => {
                      const token = localStorage.getItem(LOCALSTORAGE_TOKEN);
                      const options = {
                        headers: {
                          'Content-Type':
                            'application/json',
                          Authorization: `Token ${token}`,
                        },
                      };
                      axios
                        .delete(
                          `${URL_INSTRUCTORMAPPING}${confirm}`,
                          options,
                        )
                        .then(() => {
                          history.push({
                            pathname: `/admin/course-curriculum/${data.courseId}`,
                            search: '?tabs=4',
                          });
                        })
                        .catch(() => {
                          message.error('Something went wrong!');
                        });
                    }}
                  >
                    Delete
                  </Button>
                </ModalFooter>
              </Modal>
            </ButtonToolbar>
          </form>
        </CardBody>
      </Card>
    </Col>
  );
};

// EditInstructorForm.propTypes = {
//   handleSubmit: PropTypes.func.isRequired,
// };

export default reduxForm({
  form: 'edit_instructor', // a unique identifier for this form
  enableReinitialize: true,
})(EditInstructorForm);
